import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { compte } from "@/lib/user";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/compte", { replace: true }); return; }
    compte.googleSession(sessionId).then(() => navigate("/compte", { replace: true })).catch(() => navigate("/compte?connexion=erreur", { replace: true }));
  }, [location.hash, navigate]);

  return <main className="min-h-screen bg-sand" data-testid="auth-callback" aria-live="polite" />;
};